<div [formGroup]='parent' class="form-field">
    <div class="alignPos mb-30">
        <span for="addressSearch"> {{question.questionText}}</span>
        <div class="info-icon d-view" *ngIf="question.helpText">
            <app-tool-tip-notification [childId]="'inputComp'" [tooltipData]="initializeToolTipDateComp(question)">
            </app-tool-tip-notification>
        </div>
        <div class="info-icon mt-view" *ngIf="question.helpText">
            <app-tool-tip-notification [childId]="'inputComp'" [tooltipData]="initializeToolTipDateComp(question)"
            (onDisplayMobileTooltipEmitter)="displayDrpTooltipMessage(question)">
            </app-tool-tip-notification>

            <app-modal *ngIf="displayTooltipAlert" [modalConfig]="tooltipModalConfig" (closeModal)="closeModal()"
      (primaryBtnClick)="alertTooltipPrimaryBtnClick()" (secondaryBtnClick)="alertSecondaryBtnClick()" [tooltipFlag]="true"></app-modal>
        </div>
    </div>
    <input class="form-control wd-300" [formControlName]="controlName" id="{{domId}}"
        [placeholder]="getPlaceholder()" type="text" [(ngModel)]="enteredValue" (blur)="checkInputValues()" (input)="Search()">

    <ng-container *ngIf="addressData.length > 0 && isMedicationObjectType">
        <ul class="autofill wd-300">
            <li [id]="item.subCondition" *ngFor="let item of addressData, let i = index" [(value)]="addressData[i].subCondition" (click)="onSelectOfSearchResultsAsObj(item, true)">
                {{item.subCondition}}
            </li>
        </ul>
    </ng-container>

    <ng-container *ngIf="addressData.length > 0 && !isMedicationObjectType">
        <ul class="autofill wd-300">
            <li [id]="item" *ngFor="let item of addressData, let i = index" [(value)]="addressData[i]" (click)="onSelectOfSearchResultsAsString(item, true)">
                {{item}}
            </li>
        </ul>
    </ng-container>
</div>

<div  class="top-10 form-validation-error" *ngIf="parent.get(controlName).touched
                        &&
                    parent.get(controlName).errors">
        <i class="icon icon-error" aria-hidden="true"></i>
        <p [id]="pageName+'-'+controlName +'-error'" *ngIf="parent.get(controlName).errors.required" aria-hidden="false" role="error" aria-live="polite">Please enter the name of your {{getErrorMsgValue('required')}}</p>
        <p [id]="pageName+'-'+controlName +'-error'" *ngIf="parent.get(controlName).errors.invalid" aria-hidden="false" role="error" aria-live="polite">Please enter the name of your {{getErrorMsgValue('invalid')}}</p>
        <p [id]="pageName+'-'+controlName +'-error'" *ngIf="parent.get(controlName).errors.invalidSelect" aria-hidden="false" role="error" aria-live="polite">Please select the name of your {{getErrorMsgValue('invalidSelect')}} from the list</p>
</div>